<template>
	<div class="grid-empty" v-if="showWhen">
		<span>{{ message }}</span>
	</div>
</template>

<script>
export default {
	name: 'grid-empty',
	props: {
		showWhen: {
			type: Boolean,
			default: false
		},
		message: {
			type: String,
			require: true
		}
	}
}
</script>

<style scoped>
.grid-empty {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 20px 0;
	font-weight: 900;
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/GridEmpty.vue